import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['level', 'duration', 'language', 'comboValue']
  static values = { combos: Array }

  connect() {
    if (this.hasComboValueTarget && this.comboValueTarget.value) {
      this.preselectFromValue()
    }
  }

  levelChanged() {
    this.populateDurations()
    this.clearLanguages()
    this.clearComboValue()
  }

  durationChanged() {
    this.populateLanguages()
    this.clearComboValue()
  }

  languageChanged() {
    this.resolveComboValue()
  }

  populateDurations() {
    const level = this.levelTarget.value
    const durations = []
    this.combosValue.forEach((c) => {
      if (c.level === level && !durations.some((d) => d.value === c.duration)) {
        durations.push({ value: c.duration, label: c.duration_label })
      }
    })
    this.fill(
      this.durationTarget,
      durations.map((d) => [d.label, d.value]),
    )
  }

  populateLanguages() {
    const level = this.levelTarget.value
    const duration = parseInt(this.durationTarget.value)
    const languages = this.combosValue
      .filter((c) => c.level === level && c.duration === duration)
      .map((c) => [c.language, c.value])
    this.fill(this.languageTarget, languages)
  }

  resolveComboValue() {
    this.comboValueTarget.value = this.languageTarget.value || ''
  }

  preselectFromValue() {
    const combo = this.combosValue.find(
      (c) => c.value === this.comboValueTarget.value,
    )
    if (!combo) return

    this.levelTarget.value = combo.level
    this.populateDurations()
    this.durationTarget.value = combo.duration
    this.populateLanguages()
    this.languageTarget.value = combo.value
  }

  fill(select, options) {
    select.innerHTML = '<option value=""> - Select - </option>'
    options.forEach(([label, value]) => {
      const option = document.createElement('option')
      option.value = value
      option.textContent = label
      select.appendChild(option)
    })
  }

  clearLanguages() {
    this.languageTarget.innerHTML = '<option value=""> - Select - </option>'
  }

  clearComboValue() {
    this.comboValueTarget.value = ''
  }
}
